import { chatIcons } from '../../assets/chatIcons';
import { ITextChatMessage } from '../../model/ITextChatMessage';

export const DEFAULT_INTERIM_MESSAGE = 'Thinking...';

export const STOP_RESPONSE_ICON_CLASS = 'alan-btn__chat-incomming-msg-loader-icon';

export function getMsgLoaderWrapper(content) {
    return `<div class="alan-btn__chat-incomming-msg-wrapper">${content}</div>`;
}

export function getMsgLoader(textChatOptions) {

    const icon = textChatOptions?.bubbles?.waitingResponse?.icon.svg || chatIcons.msgLoader;

    return `<span class="alan-btn__chat-incomming-msg-loader-icon-holder">
         <span class="${STOP_RESPONSE_ICON_CLASS}">${icon}</span>
        </span>`;
}

export function getMsgLoaderStatus(textChatOptions, message?: ITextChatMessage) {
    let waitingResponseBubbleLabel = textChatOptions?.bubbles?.waitingResponse?.label || DEFAULT_INTERIM_MESSAGE;

    if (message?.queryProgress) {
        const unshownStatuses = message?.queryProgress?.filter(s => s.isShown === false);
        waitingResponseBubbleLabel = unshownStatuses?.length > 0 ?
            unshownStatuses[0].text :
            (message?.queryProgress[message?.queryProgress?.length - 1].text || '')
    }

    return capitalize(waitingResponseBubbleLabel);
}

function capitalize(str: string): string {
    return str.charAt(0).toUpperCase() + str.substring(1);
}